<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{$t('topicConfiguration')|capitalize}}</span>
            </v-card-title>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                        <v-btn color="#4977EE" class="add-custom-info" @click="addNode()">
                            <v-icon>mdi-plus</v-icon>
                            {{$t('add')|capitalize}}
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                        <vue-tree-list
                                @click="onClick"
                                @change-name="onChangeName"
                                @delete-node="onDel"
                                @add-node="onAddNode"
                                :model="customInfo"
                                default-tree-node-name="new topic"
                                default-leaf-node-name="new sub topic"
                                v-bind:default-expanded="false"
                        >
                            <template v-slot:leafNameDisplay="slotProps">
                                            <span class="mx-2" style="font-size: 16px">
                                              {{ slotProps.model.name }}
                                            </span>
                            </template>
                            <span class="icon" slot="addTreeNodeIcon"><v-icon size="24" class="mx-2">mdi-folder-plus-outline</v-icon></span>
                            <span class="icon" slot="addLeafNodeIcon"><v-icon size="24" class="mx-2">mdi-shape-rectangle-plus</v-icon></span>
                            <span class="icon" slot="editNodeIcon"><v-icon size="24" class="mx-2">mdi-square-edit-outline</v-icon></span>
                            <span class="icon" slot="delNodeIcon"><v-icon size="24" class="mx-2">mdi-trash-can-outline</v-icon></span>
                            <span class="icon" slot="leafNodeIcon"><v-icon>mdi-file-document-outline</v-icon></span>
                            <template v-slot:treeNodeIcon="slotProps">
                                <v-icon v-if="(slotProps.model.children && slotProps.model.children.length > 0 && !slotProps.expanded)">mdi-folder</v-icon>
                                <v-icon v-else>
                                    mdi-folder-open
                                </v-icon>
                            </template>
                        </vue-tree-list>
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox :label="$t('requiredTopicMAD')" v-model=botConfig.requiredTopicMad true-value="1" false-value="0"></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                        <div class="text-xs-right">
                            <v-btn color="#4977EE" class="add-custom-info" @click="updateBtn()" :disabled="disabledUpdateBtn">
                                {{$t('update')|capitalize}}
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import {Tree, TreeNode, VueTreeList} from 'vue-tree-list';
import BotService from "@/services/bot.service";
import {mapState} from "vuex";
import i18n from "@/plugins/i18n";

export default {
        components: {
            VueTreeList
        },
        props: {
            botCode: String,
        },
        name: "CustomInfo",
        data() {
            return {
                treeData: {},
                customInfo: new Tree([]),
                disabledUpdateBtn: false,
            }
        },
        mounted() {
            if (this.botCode) {
                this.getCustomInfo();
            }
        },
        computed: {
            ...mapState('config', ['botConfig']),
        },
        watch: {
            botCode() {
                if (this.botCode) {
                    this.getCustomInfo();
                }
            },
        },
        methods: {
            onDel(node) {
                node.remove()
            },

            onChangeName(params) {
                if (params.newName === "") {
                    this.disabledUpdateBtn = true
                }
                else {
                    this.disabledUpdateBtn = false
                }
            },
            onAddNode(params) {
                console.log(params)
            },

            onClick(params) {
                console.log(params)
            },
            addNode() {
                var node = new TreeNode({ name: 'new topic', isLeaf: false})
                if (!this.customInfo.children) this.customInfo.children = []
                this.customInfo.addChildren(node)
            },
            getNewTree() {
                var vm = this
                function _dfs(oldNode) {
                    var newNode = {}

                    for (var k in oldNode) {
                        if (k !== 'children' && k !== 'parent') {
                            newNode[k] = oldNode[k]
                        }
                    }

                    if (oldNode.children && oldNode.children.length > 0) {
                        newNode.children = []
                        for (var i = 0, len = oldNode.children.length; i < len; i++) {
                            newNode.children.push(_dfs(oldNode.children[i]))
                        }
                    }
                    return newNode
                }

                vm.treeData = _dfs(vm.customInfo)
            },
            getCustomInfo(){
                BotService.getCustomInfo(this.botCode)
                    .then((res)=>{
                        this.customInfo = new Tree([]);
                        this.customInfo = new Tree(res.data.data.children);
                    })
                    .catch(()=>{
                        this.$AppService.handleRequestError(this.$t('configTopicFailure'))
                    })
            },
            updateBtn() {
                this.getNewTree();
                const updateData = {
                  topic_data: this.treeData,
                  is_required_topic: this.botConfig['requiredTopicMad']
                }
                BotService.saveCustomInfo(this.botCode, updateData)
                    .then(()=> {
                        this.$AppService.toastSuccess(this.$t('configTopicSuccess'))
                    })
                    .catch(()=> {
                        this.$AppService.handleRequestError(this.$t('configTopicFailure'))
                    })
            }
        }
    }
</script>

<style scoped>
    .add-custom-info {
        color: #FFFFFF;
        text-transform: none;
        font-weight: bold;
        border-radius: 5px !important;
        margin-left: 0px !important;
    }
    ::v-deep .v-card {
        border-radius: 4px !important;
    }
    .headline {
        color: #FFFFFF;
        font-size: 18px !important;
        line-height: 30px;
    }
    ::v-deep .vue-treeselect__menu-container .vue-treelist__menu {
        background-color: red !important;
    }
</style>
